import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "relative w-full max-w-md mx-auto"
};
const _hoisted_2 = {
  class: "relative"
};
const _hoisted_3 = {
  class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
};
const _hoisted_4 = ["onKeydown"];
const _hoisted_5 = {
  class: "py-1"
};
const _hoisted_6 = ["onClick"];
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { Search } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';
// import { Search as SearchIcon } from 'lucide-vue-next'

// Define the interface for search results
/**
 * @typedef {Object} SearchResult
 * @property {string} id
 * @property {string} title
 * @property {string} description
 */

export default {
  __name: 'searchInput',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const router = useRouter();

    // Reactive state
    const query = ref('');
    const isOpen = ref(false);
    const results = ref([]);
    const inputRef = ref(null);
    const dropdownRef = ref(null);
    const props = __props;
    const data = computed(() => props.data);

    // Watch for query changes to update results
    watch(query, newQuery => {
      if (newQuery.trim() === '') {
        results.value = [];
        return;
      }

      // Simulate API call with mock data
      const mockResults = Object.keys(data.value).filter(item => `${item} ${data.value[item].brand_name}`.toLowerCase().includes(newQuery.trim().toLowerCase()));
      results.value = mockResults;
    });

    /**
     * Select a result and close the dropdown
     * @param {SearchResult} result
     */
    const selectFirst = () => {
      if (results.value.length) selectResult(`/coupon/${results.value[0]}/code`);
    };
    const selectResult = result => {
      router.push(result);
      isOpen.value = false;
    };

    // Handle click outside to close dropdown
    const handleClickOutside = event => {
      if (dropdownRef.value && !dropdownRef.value.contains(event.target) && inputRef.value && !inputRef.value.contains(event.target)) {
        isOpen.value = false;
      }
    };

    // Add event listener when component is mounted
    onMounted(() => {
      document.addEventListener('mousedown', handleClickOutside);
    });

    // Remove event listener when component is unmounted
    onUnmounted(() => {
      document.removeEventListener('mousedown', handleClickOutside);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(Search), {
        class: "h-5 w-5 text-orange-500"
      })]), _withDirectives(_createElementVNode("input", {
        ref_key: "inputRef",
        ref: inputRef,
        type: "search",
        placeholder: "Search...",
        class: "w-full pl-10 py-2 px-4 rounded-md bg-white border border-orange-300 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value = $event),
        "aria-label": "Search stores",
        onKeydown: [_withKeys(_withModifiers(selectFirst, ["prevent"]), ["enter"]), _cache[1] || (_cache[1] = _withKeys($event => isOpen.value = false, ["esc"]))],
        onFocus: _cache[2] || (_cache[2] = $event => isOpen.value = true)
      }, null, 40, _hoisted_4), [[_vModelText, query.value]])]), isOpen.value && results.value.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "dropdownRef",
        ref: dropdownRef,
        class: "absolute z-50 w-full mt-1 bg-white rounded-md shadow-lg max-h-60 overflow-auto"
      }, [_createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, result => {
        return _openBlock(), _createElementBlock("li", {
          key: result,
          class: "px-4 py-2 hover:bg-orange-50 cursor-pointer",
          onClick: $event => selectResult(`/coupon/${result}/code`)
        }, _toDisplayString(result), 9, _hoisted_6);
      }), 128))])], 512)) : _createCommentVNode("", true)]);
    };
  }
};